import type { ConceptDef } from '../types';

export const tactNumbers: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-numbers',
  label: 'Expressive Numbers',
  category: 'Expressive',
  description: 'Show a numeral; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '1' },
      { prompt: '2' },
      { prompt: '3' },
      { prompt: '4' },
      { prompt: '5' },
      { prompt: '6' },
      { prompt: '7' },
      { prompt: '8' },
    ],
  },
};
